const initReviews = () => {
  const url = "https://www.societe-des-avis-garantis.fr/wp-content/plugins/ag-core/widgets/iframe/2/h/?id=8025";
  const lbcAvisGarantis = document.querySelectorAll(".lbc-avis-garantis");

  if (lbcAvisGarantis.length <= 0) return;

  fetch(url)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");
      const score = doc.querySelector(".raty[data-score]").getAttribute("data-score");
      const numberOfFullStars = Math.ceil(score);
      const numberOfEmptyStars = 5 - numberOfFullStars;

      const emptyStar = `<svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7703 10.3429L14.5 1.94164L17.2297 10.3429L17.8004 10.1574L17.2297 10.3429C17.3502 10.7137 17.6958 10.9647 18.0857 10.9647H26.9192L19.7727 16.157C19.4573 16.3862 19.3253 16.7924 19.4458 17.1632L22.1755 25.5644L15.029 20.3722C14.7136 20.143 14.2864 20.143 13.971 20.3722L6.82449 25.5644L9.55421 17.1632C9.6747 16.7924 9.54271 16.3862 9.22727 16.157L2.08076 10.9647H10.9143C11.3042 10.9647 11.6498 10.7137 11.7703 10.3429ZM6.53917 26.4426L6.53937 26.4419L6.53917 26.4426ZM1.33379 10.422C1.33397 10.4222 1.33415 10.4223 1.33432 10.4224L1.33379 10.422L1.15746 10.6647L1.33379 10.422Z" stroke="black" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>`;
      const fullStar = `<svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7703 10.3429L14.5 1.94164L17.2297 10.3429L17.8004 10.1574L17.2297 10.3429C17.3502 10.7137 17.6958 10.9647 18.0857 10.9647H26.9192L19.7727 16.157C19.4573 16.3862 19.3253 16.7924 19.4458 17.1632L22.1755 25.5644L15.029 20.3722C14.7136 20.143 14.2864 20.143 13.971 20.3722L6.82449 25.5644L9.55421 17.1632C9.6747 16.7924 9.54271 16.3862 9.22727 16.157L2.08076 10.9647H10.9143C11.3042 10.9647 11.6498 10.7137 11.7703 10.3429ZM6.53917 26.4426L6.53937 26.4419L6.53917 26.4426ZM1.33379 10.422C1.33397 10.4222 1.33415 10.4223 1.33432 10.4224L1.33379 10.422L1.15746 10.6647L1.33379 10.422Z" fill="#F8FF66" stroke="black" stroke-width="1.2" stroke-linejoin="round"/>
</svg>`;

      const scoreContainer = `
        <div class="lbc-avis-garantis__score">
          ${Array.from({ length: numberOfFullStars }, () => fullStar).join("")}
          ${Array.from({ length: numberOfEmptyStars }, () => emptyStar).join("")}
        </div>
      `;

      lbcAvisGarantis.forEach(lbcAvisGarantisEl => {
        const additionalTextOption = lbcAvisGarantisEl.hasAttribute("data-additional-text");
        const additionalText = additionalTextOption ? "sur Société des avis Garantis" : "";
        const numberOfReviews = doc.querySelector("#ratingLabel").innerText + additionalText;

        lbcAvisGarantisEl.insertAdjacentHTML("afterbegin", scoreContainer);
        lbcAvisGarantisEl.insertAdjacentHTML("beforeend", "<p class='lbc-avis-garantis__number-of-reviews'>" + numberOfReviews + "</p>");
      });
    });
}

initReviews();